const BASE_URL = '/'
const SIGN_IN = BASE_URL
const HOME = `${BASE_URL}home`
const MICROSOFT_CALLBACK = `${BASE_URL}callback`
const ADMIN = `${BASE_URL}admin`
const ADMIN_USERS = `${ADMIN}/users`
const ADMIN_BOARDS = `${ADMIN}/boards`
const CLIENTS = `${BASE_URL}clients`
const REGISTERS = `${BASE_URL}registers`
const REGISTERS_TICKETS = `${REGISTERS}/tickets`
const REGISTERS_TICKETS_LINK_CLIENTS = `${REGISTERS}/tickets-link-clients`
const REPORTS = `${BASE_URL}reports`
const REPORTS_MONTHLY = `${REPORTS}/monthly`
const REPORTS_ACCUMULATED = `${REPORTS}/accumulated`
const REPORTS_PRODUCTIVITY = `${REPORTS}/productivity`
const BILLINGS = `${BASE_URL}billings`
const NOTIFICATIONS = `${BASE_URL}notifications`
const NOTIFICATIONS_FRANCHISE = `${NOTIFICATIONS}/franchise`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  SIGN_IN,
  MICROSOFT_CALLBACK,
  HOME,
  ADMIN_USERS,
  ADMIN_BOARDS,
  CLIENTS,
  REGISTERS_TICKETS,
  REGISTERS_TICKETS_LINK_CLIENTS,
  REPORTS_MONTHLY,
  REPORTS_ACCUMULATED,
  REPORTS_PRODUCTIVITY,
  BILLINGS,
  NOTIFICATIONS_FRANCHISE,
  UNAUTHORIZED,
}
